import request from '../request.js';

export function login(data) {
    return request({
        url: '/auth/login',
        method: 'post',
        data: data,
    });
}

export function register(data) {
    return request({
        url: '/auth/registration',
        method: 'post',
        data: data,
    });
}

export function getInfo(token) {
    return request({
        url: '/auth/user',
        method: 'get',
    });
}

export function logout() {
    return request({
        url: '/auth/logout',
        method: 'post',
    });
}

export function requestPasswordChange(data) {
    return request({
        url: 'auth/request/passwordSet',
        method: 'post',
        data: data,
    });
}

export function resetPassword(data) {
    return request({
        url: '/auth/reset/password',
        method: 'post',
        data: data,
    });
}